import { ThemeProvider } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import { theme } from '../theme';
import ChecklistPage from './checklist/ChecklistPage';
import CompoundPage from './compound/CompoundPage';
import SevenKnightsCouponPage from './coupon/seven-knights/SevenKnightsCouponPage';
import GuidePage from './guide/GuidePage';
import { HomePage } from './home/HomePage';
import InflationPage from './inflation/InflationPage';
import { Layout } from './Layout/Layout';
import PensionPage from './pension/PensionPage';
import { PrivacyPolicyPage } from './privacy-policy/PrivacyPolicyPage';
import RetirementGoalPage from './retirement-goal/RetirementGoalPage';
import RetirementPage from './retirement/RetirementPage';
import RouteChangeTracker from './RouteChangeTracker';
import TaxBenefitPage from './tax-benefit/TaxBenefitPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouteChangeTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/compound" element={<CompoundPage />} />
          <Route path="/pension" element={<PensionPage />} />
          <Route path="/retirement" element={<RetirementPage />} />
          <Route path="/retirement/goal" element={<RetirementGoalPage />} />
          <Route path="/tax-benefit" element={<TaxBenefitPage />} />
          <Route path="/inflation" element={<InflationPage />} />
          <Route path="/checklist" element={<ChecklistPage />} />
          <Route path="/guide" element={<GuidePage />} />
          <Route path="/coupon/seven-knights" element={<SevenKnightsCouponPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
